import React from 'react';

export enum QueryRunTypeEnum {
  RUN,
  RUN_CONTINUE
}

export enum QueryEditorBadgeType {
  UNVERIFIED_CHANGES = 'UNVERIFIED_CHANGES',
  DRAFT_QUERY = 'DRAFT_QUERY',
  UNSAVED_CHANGES = 'UNSAVED_CHANGES'
}

export enum QueryExecutionStatusEnum {
  IDLE,
  REQUEST_ID,
  RUNNING,
  QUEUED,
  REQUEST_CANCEL,
  CANCEL_REQUESTED,
  CANCELLED,
  SUCCESS,
  FAILED,
  ERRORED,
  UPDATING,
  UPDATE_FAILED
}

export interface QueryExecutionResponse {
  data?: {
    output: any;
    hasMoreResults: boolean;
    runTime: number;
  };
  error?: any;
  status: QueryExecutionStatusEnum;
}

export interface WorkbenchQueryEditorConfiguration {
  focusEditorOnLoad?: boolean;
  runQueryText?: string;
  runningQueryText?: string;
  showProcessedRowsCount?: boolean;
  elapsedTimerEnabled?: boolean;
  queryEditorBadgeType?: QueryEditorBadgeType;
  draftQueryTooltipMessage?: string;
  QueryEditorHeaderActions?: React.ElementType;
  QueryEditorFooterActions?: React.ElementType;
  queryTooltipMessage?: string;
}
